import {
  Autocomplete,
  Box,
  Button,
  ButtonBase,
  Modal,
  TextField,
  styled,
} from "@mui/material";
import { makeStyles } from "@material-ui/styles";
import { Card, CardActionArea } from "@mui/material";
import {
  APP_BACKGROUND_COLOR,
  APP_COLOR,
  APP_HOVER_COLOR,
  FONT_FAMILY,
  TEXT_COLOR,
} from "../../theme";

export const MintButton = styled(Button)(({ theme }) => ({
  margin: "10px",
  "&:hover": {
    backgroundColor: APP_HOVER_COLOR,
  },
  backgroundColor: APP_COLOR,
  textTransform: "none",
  fontFamily: FONT_FAMILY,
  width: "120px",
  color: "black",
  [theme.breakpoints.down("sm")]: {
    margin: "10px 4px 25px",
    width: "200px",
  },
}));

export const WaveformContainer = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const ContainerModal = styled(Modal)({ overflow: "auto" });

export const useStyles = makeStyles({
  customTextField: {
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
  selectStyle: {
    fontFamily: FONT_FAMILY,
  },
});

export const UsernameSelectField = styled(Autocomplete)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#cbd2e0",
      borderWidth: 2,
      height: 57,
    },
    "&:hover fieldset": {
      borderColor: "#cbd2e0",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#cbd2e0",
    },
  },
});

export const EmailInviteTextField = styled(TextField)({
  width: "100%",
  fontFamily: FONT_FAMILY,
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#cbd2e0",
      borderWidth: 2,
      height: 57,
    },
    "&:hover fieldset": {
      borderColor: "#cbd2e0",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#cbd2e0",
    },
  },
});

export const ModalButton = styled(Button)({
  fontFamily: FONT_FAMILY,
  marginTop: 16,
  padding: 8,
  width: 110,
  textTransform: "none",
  color: "black",
  "&:hover": {
    backgroundColor: APP_HOVER_COLOR,
  },
  backgroundColor: APP_COLOR,
});

export const autoCompleteStlye = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#cbd2e0",
      borderWidth: 2,
    },
    "&:hover fieldset": {
      borderColor: "#cbd2e0",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#cbd2e0",
    },
  },
};

export const autoCompleteErrorStyle = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "red",
      borderWidth: 2,
    },
    "&:hover fieldset": {
      borderColor: "red",
    },
    "&.Mui-focused fieldset": {
      borderColor: "red",
    },
  },
};

export const StyledCard = styled(Card)(({ theme }) => ({
  margin: 0,
  padding: 0,
  width: "20vw",
  boxShadow: "0 5px 25px 0 rgba(0, 0, 0, 0.6)",
  borderRadius: 15,
  backgroundColor: APP_BACKGROUND_COLOR,
  color: "white",
  [theme.breakpoints.up("md")]: {
    width: "22vw",
  },
  [theme.breakpoints.down("md")]: {
    width: "40vw",
  },
  [theme.breakpoints.down("sm")]: {
    width: "85vw",
  },
}));

export const StyledCardAdd = styled(ButtonBase)(({ theme }) => ({
  marginBottom: 20,
  marginRight: 20,
  width: "100%",
  boxShadow: "0 5px 25px 0 rgba(0, 0, 0, 0.6)",
  borderRadius: 5,
  height: 50,
  color: "black",
  fontWeight: 500,
  "&:hover": {
    backgroundColor: APP_HOVER_COLOR,
  },
  backgroundColor: APP_COLOR,
  textTransform: "none",
  fontFamily: FONT_FAMILY,
  [theme.breakpoints.up("sm")]: {
    width: "35%",
  },
  [theme.breakpoints.up("md")]: {
    width: "18.5%",
  },
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    display: "flex",
  },
}));

export const ReloadButton = styled(ButtonBase)(({ theme }) => ({
  marginBottom: 20,
  marginRight: 20,
  width: "6%",
  boxShadow: "0 5px 25px 0 rgba(0, 0, 0, 0.6)",
  borderRadius: 5,
  height: 50,
  color: "black",
  fontWeight: 500,
  "&:hover": {
    backgroundColor: APP_HOVER_COLOR,
  },
  backgroundColor: APP_COLOR,
  textTransform: "none",
  fontFamily: FONT_FAMILY,
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

export const UploadButton = styled(Button)(({ theme }) => ({
  width: 140,
  boxShadow: "0 5px 25px 0 rgba(0, 0, 0, 1)",
  height: 45,
  marginTop: 30,
  color: "black",
  fontWeight: 500,
  "&:hover": {
    backgroundColor: APP_HOVER_COLOR,
  },
  backgroundColor: APP_COLOR,
  textTransform: "none",
  fontFamily: FONT_FAMILY,
}));

export const StyledCardActionArea = styled(CardActionArea)(({ theme }) => ({
  margin: 0,
  padding: 0,
  flexDirection: "column",
  justifyContent: "flex-start",
  backgroundColor: APP_BACKGROUND_COLOR,
  overflow: "hidden",
}));

export const styles = {
  libraryContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "0px 10px 5px 10px",
    fontFamily: FONT_FAMILY,
    margin: "40px 0",
  } as const,
  headerContainer: {
    display: "flex",
    alignSelf: "center",
  } as const,
  header: {
    fontSize: 28,
    margin: "20px 0 40px",
    fontWeight: "bold",
    textAlign: "center",
  } as const,
  addIcon: { color: "black", width: "30px", height: "30px" } as const,
  playbackIcons: { height: 25, width: 25 } as const,
  titleArtist: { flexGrow: 1, marginLeft: 5, marginTop: "20px" } as const,
  title: {
    fontFamily: FONT_FAMILY,
    fontSize: 14,
    fontWeight: "bold",
  } as const,
  currentVersionLabel: {
    fontFamily: FONT_FAMILY,
    fontSize: 12,
    fontWeight: "bold",
  } as const,
  CurrentVersionCount: {
    fontFamily: FONT_FAMILY,
    fontSize: 12,
    fontWeight: "bold",
  } as const,
  artist: { fontFamily: FONT_FAMILY, fontSize: 14 } as const,
  genreContainer: {
    marginRight: 5,
    display: "flex",
    alignItems: "flex-end",
    marginTop: 20,
    flexDirection: "column",
  } as const,
  genreLabel: {
    fontFamily: FONT_FAMILY,
    fontSize: 12,
    color: "white",
    marginRight: 1,
    fontWeight: 600,
  } as const,
  contributorsLabel: {
    fontFamily: FONT_FAMILY,
    fontSize: 12,
    color: "white",
    marginRight: 1,
    marginBottom: 1,
    fontWeight: 600,
    flexGrow: 1,
  } as const,
  spinner: { marginTop: 10, marginLeft: 10 } as const,
  modalHeader: {
    fontFamily: FONT_FAMILY,
    fontSize: 20,
    fontWeight: "bold",
    flexGrow: 1,
    color: TEXT_COLOR,
  } as const,
  modalHeaderContainer: { display: "flex", alignItems: "center" } as const,
  modalImagePlaceholder: {
    color: TEXT_COLOR,
    width: "50px",
    height: "50px",
  } as const,
  modalDescription: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: "white",
    borderColor: "white",
  } as const,
  modalBpmLabel: {
    color: TEXT_COLOR,
    marginBottom: 0,
    fontSize: 16,
    fontFamily: FONT_FAMILY,
    fontWeight: "500",
  } as const,

  modalCreatorUsername: {
    display: "block",
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    marginBottom: 8,
    fontWeight: 500,
  } as const,
  modalCreatorButton: {
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginY: 3,
    marginTop: -9,
    paddingY: 1,
  } as const,
  modalCreaterButtonText: {
    fontFamily: FONT_FAMILY,
    fontSize: 20,
    fontWeight: "400",
  } as const,
  modalSubmitButton: {
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginY: 3,
    paddingY: 1,
    height: 50,
  } as const,
  modalSubmitButtonText: {
    fontFamily: FONT_FAMILY,
    fontSize: 20,
    fontWeight: "400",
  } as const,
  postMessageModal: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: APP_BACKGROUND_COLOR,
    alignItems: "center",
    justifyContent: "center",
    padding: 40,
    position: "relative",
  } as const,
  postMessageModalIcon: {
    position: "absolute",
    top: 15,
    right: 15,
    color: APP_COLOR,
  } as const,
  paymentComponentContainer: {
    textAlign: "center",
    margin: "auto",
  } as const,
  noTrackContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    height: "50vh",
    alignItems: "center",
  } as const,
  fileUploadContainer: {
    height: "100%",
    borderStyle: "dashed",
    borderWidth: "2px",
    borderColor: "white",
    display: "flex",
    flexDirection: "column",
  } as const,
  noTrackText: {
    fontFamily: FONT_FAMILY,
    fontWeight: 600,
    fontSize: 18,
    color: "white",
    textAlign: "center",
  } as const,
  submittingContainer: {
    color: APP_COLOR,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "50vh",
    alignItems: "center",
  } as const,
  waveform: {
    minWidth: "100%",
    overflow: "hidden",
    marginTop: "25px",
  } as const,
  trackControlsAndTrackDetailsContainer: {
    display: "flex",
    width: "auto",
    justifyContent: "space-between",
    padding: "0 5px 0 5px",
  } as const,
  linearProgress: {
    flexGrow: 1,
    marginBottom: 5,
    marginTop: 5,
    color: "#27B6CB",
  } as const,
  linearProgressContainer: {
    width: "100%",
    color: APP_COLOR,
    height: "50vh",
    paddingTop: 20,
  } as const,
  uploading: {
    color: "white",
    fontFamily: FONT_FAMILY,
    marginBottom: 5,
    fontSize: 16,
  } as const,
  extensionContainer: {
    display: "flex",
    alignContent: "center",
    backgroundColor: "#203e5e",
    padding: "10px",
    borderRadius: "5px",
  } as const,
  removeAllFileButton: {
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    color: "black",
    marginY: 2,
    boxShadow: "0 5px 25px 0 rgba(0, 0, 0, 0.6)",
    textTransform: "none",
    fontFamily: FONT_FAMILY,
  } as const,
  uploadFileContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: 20,
    marginBottom: 10,
  } as const,
  extensionNameContainer: {
    flexDirection: "column",
    marginLeft: 20,
    fontSize: 14,
    flexGrow: 1,
  } as const,
  fileTypeSelect: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: TEXT_COLOR,
    borderColor: TEXT_COLOR,
  } as const,
  AddTrackTextContainer: {
    marginLeft: 10,
    fontFamily: FONT_FAMILY,
    fontSize: "20px",
  } as const,
  progressContainer: {
    width: "100%",
    paddingY: 4,
    color: APP_COLOR,
  } as const,
  file: {
    height: 155,
    borderStyle: "dashed",
    borderWidth: "2px",
  } as const,
  fileLabel: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: TEXT_COLOR,
    borderColor: TEXT_COLOR,
  } as const,
  popupContainer: {
    position: "fixed",
    bottom: "5px",
    right: "10px",
    backgroundColor: "black",
    color: "white",
    boxShadow: "24px",
    padding: "16px",
    margin: "0 10px 10px 0",
    zIndex: 30000,
    borderRadius: "5px",
    width: "400px",
    height: "100px",
  } as const,
  selectFieldStyle: {
    ".MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
  } as const,
};

export const VersionContainer = styled(Box)(({ theme }) => ({
  height: "auto",
  display: "flex",
  [theme.breakpoints.down("md")]: {},
  [theme.breakpoints.down("sm")]: {
    maxWidth: "calc(80%)",
  },
  flexDirection: "column-reverse",
}));

export const SelectContainer = styled(Box)(({ theme }) => ({
  width: "200px",
  display: "flex",
  marginTop: "20px",
  marginBottom: "20px",
  justifyContent: "flex-end",
  [theme.breakpoints.down("sm")]: {
    justifyContent: "left",
  },
}));

export const SelectVersionModalContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  border: "2px solid #000",
  // boxShadow: 24,
  padding: "15px",
  overflowY: "scroll",
  height: "90vh",
  [theme.breakpoints.down("md")]: {
    width: "80%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "90%",
  },
}));

export const GenresDetailsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const TrackContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  marginBottom: "10px",
}));

export const VersionsAndCollaboratorsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  padding: "10px 5px 0 15px",
  marginTop: "5px",
  [theme.breakpoints.down("sm")]: {
    padding: "10px 5px 0px 10px",
    width: "310px",
  },
}));

export const MenuItemsContainer = styled(Box)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.down("sm")]: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "-15px",
  },
}));

export const SortFilterContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "20px",
  flexWrap: "wrap",
  margin: "15px 0 25px, 0",
  [theme.breakpoints.down("sm")]: {
    justifyContent: "center",
  },
}));
